import _ from 'lodash';
import GatewayService from '../GatewayService.js';
var autosave = new GatewayService('autosave-service');

var fetchAutosave = function fetchAutosave(userKey, cardstackKey) {
  return autosaveExists(userKey, cardstackKey).then(function (exists) {
    if (exists) {
      return autosave.get("autosave/".concat(userKey, "/").concat(cardstackKey));
    } else {
      return;
    }
  });
};
/**
 *
 * @param {String} userKey
 * @param {String} prefix
 * @return {Promise<Array<Object>>} A promise resolving to an array of autosaves
 */


var fetchAutosavesByPrefix = function fetchAutosavesByPrefix(userKey, prefix) {
  return autosave.get("autosave/".concat(userKey, "/all/").concat(prefix));
};
/**
 *
 * @param {Array<String>} userKeys
 * @param {Array<String>} cardstackKeys
 * @param {Boolean} includeFileUserKey Whether to include the user key against which the autosave file is saved along
 *                                     with the payload of each autosave
 * @return {Promise<Array<Object>>} A promise resolving to an array of autosaves grouped by cardstacks and userId
 */


var fetchBulkAutosaves = function fetchBulkAutosaves(userKeys, cardstackKeys) {
  var includeFileUserKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var reqBody = {
    users: userKeys,
    prefixes: cardstackKeys
  };
  return autosave.post('autosave/all', reqBody, {
    params: {
      includeData: true
    }
  }).then(function (resp) {
    // this end point returns as a map of cardstack ids to stringified payloads
    // we parse it into a more manageable form here
    return _.map(resp, function (submissionGroup, key) {
      var data = JSON.parse(submissionGroup);

      if (includeFileUserKey) {
        data.fileUserKey = key.split('/')[0];
      }

      return data;
    });
  });
};

var autosaveExists = function autosaveExists(userKey, cardstackKey) {
  var fileKey = cardstackKey;
  var data = [{
    userKey: userKey,
    fileKey: fileKey
  }];
  return autosave.post('autosave/exists', data, {
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(function (data) {
    return _.get(data, "".concat(userKey, "/").concat(fileKey), false);
  });
};

var writeAutosave = function writeAutosave(userKey, cardstackKey, response) {
  var firstOrNewSinceSubmit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  return autosave.post("autosave/".concat(userKey, "/").concat(cardstackKey, "?firstOrNewSinceSubmit=").concat(firstOrNewSinceSubmit.toString()), response, {
    headers: {
      'Content-Type': 'text/plain'
    }
  });
};

var deleteAutosaves = function deleteAutosaves(userKey) {
  var cardstackKeys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return autosave["delete"]("autosave/all/".concat(userKey), {
    headers: {
      'Content-Type': 'application/json'
    },
    data: JSON.stringify(cardstackKeys)
  });
};

export default {
  fetchAutosave: fetchAutosave,
  fetchAutosavesByPrefix: fetchAutosavesByPrefix,
  fetchBulkAutosaves: fetchBulkAutosaves,
  writeAutosave: writeAutosave,
  deleteAutosaves: deleteAutosaves,
  autosaveExists: autosaveExists
};